import { render, staticRenderFns } from "./DocumentAddition.vue?vue&type=template&id=866f9edc&scoped=true&"
import script from "./DocumentAddition.vue?vue&type=script&lang=js&"
export * from "./DocumentAddition.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAddition.vue?vue&type=style&index=0&id=866f9edc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866f9edc",
  null
  
)

export default component.exports